import { render, staticRenderFns } from "./EditBrandTierDialog.vue?vue&type=template&id=71eb72e8&scoped=true"
import script from "./EditBrandTierDialog.vue?vue&type=script&lang=js"
export * from "./EditBrandTierDialog.vue?vue&type=script&lang=js"
import style0 from "./EditBrandTierDialog.vue?vue&type=style&index=0&id=71eb72e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb72e8",
  null
  
)

export default component.exports